export default "__VITE_ASSET__D9jefRf4__"